import { render, staticRenderFns } from "./kraken.vue?vue&type=template&id=e6dd6fd8&scoped=true"
import script from "./kraken.vue?vue&type=script&lang=js"
export * from "./kraken.vue?vue&type=script&lang=js"
import style0 from "./kraken.vue?vue&type=style&index=0&id=e6dd6fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dd6fd8",
  null
  
)

export default component.exports